import { apiExternalStatuses } from '~constants/api';

import { get, post } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'company-external-api-statuses';

const config = [
  { actionType: 'getAll', apiPath: apiExternalStatuses, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiExternalStatuses}/${params.id}`, method: get },
  { actionType: 'upsert', apiPath: apiExternalStatuses, method: post },
];

export const { getAll, getOne, upsert } = createThunks(typePrefix, config);
